import { render, staticRenderFns } from "./AddToCalendar.vue?vue&type=template&id=37035dca&scoped=true&"
import script from "./AddToCalendar.vue?vue&type=script&lang=js&"
export * from "./AddToCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AddToCalendar.vue?vue&type=style&index=0&id=37035dca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37035dca",
  null
  
)

export default component.exports